// Ansichtseinstellungen in der Adresse halten, damit Lesezeichen, Links und Neuladen sie behalten.

/**
 * Schreibt Einstellungen in die Abfrage der aktuellen Adresse (ersetzt den Verlaufseintrag); leere Werte entfernen die
 * Angabe, alle anderen Angaben der Adresse bleiben stehen.
 */
export function abfrageSetzen(werte: Record<string, string | null | undefined>): void {
  const q = new URLSearchParams(location.search);
  for (const [k, v] of Object.entries(werte)) {
    if (v) q.set(k, v);
    else q.delete(k);
  }
  const s = q.toString();
  const ziel = location.pathname + (s ? '?' + s : '') + location.hash;
  if (ziel !== location.pathname + location.search + location.hash) history.replaceState(history.state, '', ziel);
}

/**
 * Wie abfrageSetzen für Einstellungen mit Standardwert: Abweichendes steht immer in der Adresse, der Standardwert nur,
 * wenn die Angabe dort schon steht (Link aus dem Cockpit, vorher geänderte Auswahl) – so bleiben normale Adressen kurz.
 */
export function abfrageHalten(werte: Record<string, [wert: string, standard: string]>): void {
  const q = new URLSearchParams(location.search);
  abfrageSetzen(Object.fromEntries(Object.entries(werte).map(([k, [wert, standard]]) => [k, wert !== standard || q.has(k) ? wert : null])));
}

/** Wert einer Angabe aus der aktuellen Adresse, nur wenn er erlaubt ist. */
export function abfrageWert<T extends string>(name: string, erlaubt: readonly T[]): T | null {
  const v = new URLSearchParams(location.search).get(name);
  return v !== null && (erlaubt as readonly string[]).includes(v) ? (v as T) : null;
}
